import { injectable, inject } from 'inversify';
import Client from '@dealroadshow/socket-frontend-sdk';
import Container from '@framework/di/Container';
import OTelInstrument from '@framework/otel/OTelInstrument';
import type { ISocketDispatcher } from './DI/interfaces';
import DITypes from './DI/types';

@injectable()
export default class SocketClient extends Client {
  constructor(
    @inject(DITypes.SocketDispatcher) dispatcher: ISocketDispatcher,
    @inject(Container) container: Container,
  ) {
    super(dispatcher);

    OTelInstrument<typeof this.subscribe>(
      this,
      'subscribe',
      container,
      (request) => `socket.subscribe: ${ request.method }`,
      (request) => {
        return {
          attributes: {
            'rpc.method': request.method,
          },
        };
      },
    );
  }
}
